import { ArticlesList } from '../../components';
import { withLayout } from '../../Layout/Layout';
import Head from 'next/head';
import React from 'react';

function TopLists() {
  return (
    <>
      <Head>
        <meta
          name="description"
          content={
            'Explore curated top lists of travel destinations on First-Class.com. Find inspiration for your next luxury getaway'
          }
        />
        <title>
          Destination Toplists: Ranking the Best Travel Destinations
        </title>
      </Head>
      <ArticlesList
        subtype="Toplists"
        type="Destinations"
        heading="Finest Selection"
      />
    </>
  );
}

export default withLayout(TopLists, true);
